module.exports = __webpack_public_path__ + "img/logo.75121e21.png";